'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ExtraHotSvg;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ExtraHotSvg(props) {
    var size = props.size,
        primaryColor = props.primaryColor,
        _props$i18n = props.i18n,
        i18n = _props$i18n === undefined ? { get: function get() {
            return null;
        } } : _props$i18n;

    return _react2.default.createElement(
        'svg',
        { role: 'img', 'aria-labelledby': 'outImgXHot', width: size, height: size, viewBox: '0 0 28 28', xmlns: 'http://www.w3.org/2000/svg', 'data-hook': 'wixrest-menus-icon-outline-extra-hot' },
        _react2.default.createElement(
            'title',
            { id: 'outImgXHot' },
            i18n.get('openrest_menubuilderv3_dishlabels_extrahot') || 'Extra Hot'
        ),
        _react2.default.createElement(
            'g',
            { fill: primaryColor },
            _react2.default.createElement('path', {
                d: 'M21.5479 15.4638c.208 1.107-.799 2.899-2.505 4.459-1.575 1.438-4.37 1.745-5.209 1.513.151-.045.362-.087.534-.12 1.011-.202 2.703-.539 3.65-2.561.382-.814.434-1.62.476-2.269.01-.146.019-.287.032-.42.079-.84.321-1.409.703-1.645.41-.254.981-.12 1.389.038.537.208.842.536.93 1.005m.924-3.642c-.329-.114-.658-.087-.958.078-.551.305-.876 1.02-1.046 1.521-.825-.2-1.395-.02-1.739.192-.654.405-1.04 1.201-1.149 2.364-.013.141-.023.292-.034.448-.038.598-.083 1.275-.389 1.928-.742 1.587-1.98 1.833-2.974 2.03-.657.131-1.475.294-1.452 1.106.005.193.09.549.604.767.314.133.761.201 1.285.201 1.524 0 3.691-.579 5.064-1.833 2.001-1.828 3.072-3.872 2.798-5.335-.09-.479-.366-1.101-1.125-1.528.142-.421.374-.895.617-1.029.062-.035.112-.039.181-.013.248.084.519-.043.607-.291.087-.247-.043-.518-.29-.606M14.5156 15.8652c-1.593 1.44-4.417 1.751-5.269 1.515.153-.044.367-.086.54-.12 1.021-.202 2.728-.538 3.684-2.559.387-.819.439-1.628.481-2.277.009-.145.018-.283.03-.413.056-.583.223-1.341.708-1.642.416-.258 1-.124 1.416.036.546.208.853.538.942 1.008.207 1.106-.81 2.895-2.532 4.452m3.466-4.627c-.09-.481-.367-1.106-1.137-1.534.144-.423.374-.89.621-1.026.066-.036.119-.042.194-.015.247.086.518-.045.604-.293.087-.247-.045-.518-.292-.604-.332-.115-.664-.087-.967.081-.548.304-.877 1.026-1.048 1.52-.844-.206-1.419-.022-1.768.195-.654.406-1.042 1.199-1.152 2.359-.013.14-.023.287-.033.441-.038.599-.082 1.278-.392 1.933-.751 1.588-2.003 1.835-3.009 2.032-.697.138-1.487.293-1.464 1.107.005.192.09.545.6.763.31.133.753.199 1.272.199 1.553 0 3.785-.598 5.142-1.826 2.018-1.826 3.102-3.869 2.829-5.332M9.8193 12.1626c-1.594 1.441-4.417 1.75-5.269 1.515.153-.044.366-.086.539-.12 1.02-.201 2.728-.538 3.684-2.558.387-.819.44-1.628.482-2.277.009-.145.018-.283.03-.414.055-.583.223-1.341.707-1.641.419-.259 1.001-.124 1.417.035.546.208.853.538.941 1.008.207 1.107-.81 2.896-2.531 4.452m3.465-4.627c-.09-.481-.366-1.106-1.136-1.534.143-.419.376-.891.621-1.026.064-.037.116-.041.192-.014.248.086.518-.045.605-.293.086-.247-.044-.518-.292-.605-.328-.113-.663-.087-.966.08-.548.304-.877 1.026-1.048 1.521-.843-.205-1.42-.022-1.769.196-.654.406-1.042 1.199-1.152 2.359-.013.14-.022.287-.032.441-.039.599-.083 1.278-.392 1.933-.752 1.587-2.004 1.834-3.01 2.031-.697.138-1.487.293-1.463 1.106.005.192.09.547.6.765.31.131.752.198 1.271.198 1.553 0 3.785-.598 5.143-1.826 2.018-1.825 3.102-3.868 2.828-5.332' }),
            _react2.default.createElement('path', {
                d: 'M13.6499 25.999c-6.81 0-12.35-5.54-12.35-12.349 0-6.81 5.54-12.35 12.35-12.35s12.35 5.54 12.35 12.35c0 6.809-5.54 12.349-12.35 12.349m0-25.999c-7.527 0-13.65 6.123-13.65 13.65 0 7.526 6.123 13.65 13.65 13.65s13.651-6.124 13.651-13.65c0-7.527-6.124-13.65-13.651-13.65' })
        )
    );
}

ExtraHotSvg.displayName = 'ExtraHotSvg';
ExtraHotSvg.propTypes = {
    size: _propTypes2.default.number,
    primaryColor: _propTypes2.default.string
};
ExtraHotSvg.defaultProps = {
    size: 28,
    primaryColor: '#c4270e'
};